export default "__VITE_ASSET__CB9YA_c3__"